<template>
  <div
    v-if="priceInfo.total"
    :class="{isFold: fold}"
    class="optionSummary priceDpBoard">
    <button type="button" class="btnFold" @click.stop="toggleFold"><span class="blind">fold</span></button>
    <div class="totalBox notranslate" :class="{minus: priceInfo.total < 0}">
      <div class="total">
        <span class="label">{{locale.total}}</span>
        <div class="value" :class="{guestType: guestTypePrice}">
          <div v-if="guestTypePrice && isGuestDiscount" class="guestTypeName">{{guestTypePrice.name[lang]}} ({{guestTypePrice.priceDiscount}})</div>
          <span class="normalPrice">{{priceFormat(priceInfo.total)}}</span>
          <span v-if="guestTypePrice" class="totalPrice">{{priceFormat(guestTypePrice.price)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import regExp from '@/common/regExp'

export default {
  name: 'Options',
  props: [
    'lang',
    'locale',
    'pageGuestType'
  ],
  computed: {
    ...mapGetters({
      getSubmitData: 'submit/getSubmitData',
      getPriceInfo: 'page/getPriceInfo',
      getPriceOption: 'page/getPriceOption',
      getGuestTypePrice: 'util/getGuestTypePrice'
    }),
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    optionSummary () {
      const submitDataValues = this.getSubmitData.filter(x => x.value && x.value.length)
      return submitDataValues
    },
    isGuestDiscount () {
      return (this.pageGuestType && this.pageGuestType.active && this.pageGuestType.discount) &&
        ((this.pageGuestType.percent.active && this.pageGuestType.percent.value !== 0) ||
        (this.pageGuestType.price.active && this.pageGuestType.price.value !== 0))
    },
    guestTypePrice () {
      const info = this.pageGuestType
      const getGuestTypePrice = info ? this.getGuestTypePrice(info, this.priceInfo.total) : null
      return info && info.active && info.discount
        ? {
          id: info.id,
          name: info.name,
          ...getGuestTypePrice
        }
        : null
    },
    priceInfo () {
      const sum = this.getPriceOption.reduce((a, b) => a + (b.quantity ? b.price * b.quantity : b.price), 0)
      const basePrice = this.getPriceInfo.price ? Number(this.getPriceInfo.price) : 0
      const baseQuantity = this.getPriceInfo.quantity ? Number(this.getPriceInfo.quantity) : 1
      const total = (basePrice + sum) * baseQuantity
      return {
        price: this.getPriceInfo.price ? basePrice : null,
        quantity: this.getPriceInfo.quantity ? baseQuantity.quantity : null,
        sum: sum,
        total: total
      }
    }
  },
  data () {
    return {
      fold: false
    }
  },
  methods: {
    getOptionPrice (option) {
      const price = option.quantity ? option.price * option.quantity : option.price
      return this.priceFormat(price)
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    toggleFold () {
      this.fold = !this.fold
    }
  }
}
</script>

<style lang="scss" scoped>
.optionSummary {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  .totalBox {
    position: relative;
    overflow: auto;
    padding: 15px;
    font-size: 1.2em;
    font-weight: bold;
    border-top: 1px solid $color-lgrey2;
    border-radius: 20px 20px 0 0;
    background: $bg-default;
    box-shadow: 0 0 5px rgba(0,0,0,0.2);
    z-index: 1;
  }
  .total {
    display: flex;
    align-items: center;
    .value {
      margin-left: auto;
      text-align: right;
    }
    .guestTypeName {
      display: block;
      font-size: 12px;
      padding: 0.2em 0.5em;
      font-size: 12px;
      font-weight: normal;
      color: $color-grey;
      border: 1px solid $color-lgrey2;
      border-radius: 4px;
      background-color: $color-white;
    }
    .guestType {
      .normalPrice {
        font-size: 0.8em;
        font-weight: normal;
        text-decoration: line-through;
        color: $color-grey;
      }
      .totalPrice {
        margin-left: 5px;
      }
    }
  }
  .btnFold {
    position: absolute;
    bottom: 100%;
    left: 50%;
    width: 80px;
    height: 20px;
    margin-left: -40px;
    border: 1px solid $color-lgrey2;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    background-color: $bg-default;
    box-shadow: 0 0 5px rgba(0,0,0,0.2);
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      border-style: solid;
      border-width: 6px;
      border-color: transparent;
      margin-top: 3px;
      border-top-color: $color-dark;
      border-bottom-color: transparent;
      transform: translate(-50%, -50%);
    }
  }
  &.isFold {
    .totalBox {
      height: 0;
      padding: 0;
      overflow: hidden;
    }
    .btnFold:before {
      margin-top: -3px;
      border-bottom-color: $color-dark;
      border-top-color: transparent;
    }
  }
  .minus {
    .value {
      color: $color-red;
    }
  }
}
@media screen and (min-width: 768px) {
  .optionSummary {
    left: 80px;
  }
}
@media screen and (min-width: 800px) {
  .optionSummary {
    left: 180px;
  }
}
@media screen and (min-width: 1024px) {
  .optionSummary {
    left: 240px;
  }
}
</style>
